import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useProfilePhoto } from "@/auth/useProfilePhoto";
import { Icon } from "./Icon";
import { LanguageMenu } from "./LanguageMenu";
import { Row } from "./Row";

function getInitials(name: string): string {
  const parts = name.trim().split(" ");
  let initials = parts[0].charAt(0).toUpperCase();
  if (parts.length > 1) {
    initials += parts[parts.length - 1].charAt(0).toUpperCase();
  }
  return initials;
}

export const UserInfo: FC = () => {
  const { t } = useTranslation("components");
  const isAuthenticated = useIsAuthenticated();
  const { accounts } = useMsal();
  const user = accounts[0];
  const profilePhoto = useProfilePhoto();

  if (!isAuthenticated || !user) return null;

  const name = user.name;

  return (
    <LanguageMenu>
      <button
        type="button"
        aria-label={t("userInfo.menuLabel")}
        className="rounded-inputs p-component-xsmall hover:bg-muted data-[state=open]:bg-muted cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        <Row align="center">
          <div className="flex size-[40px] items-center justify-center rounded-full bg-muted text-foreground text-sm font-semibold shrink-0 overflow-hidden">
            {profilePhoto ? (
              <img src={profilePhoto} alt={t("userInfo.avatarAlt")} className="size-full rounded-full object-cover" />
            ) : name ? (
              getInitials(name)
            ) : null}
          </div>
          <span className="ml-component-small text-sm font-semibold leading-none tracking-[0.15px] text-left">
            {name}
          </span>
          <Icon name="expand_more" size="smaller" className="ml-component-xsmall shrink-0" />
        </Row>
      </button>
    </LanguageMenu>
  );
};
